import { useMemo, useState } from "react";

import Image from "next/image";

import useBillboardPageContext from "pages/[tenant]/browse/hooks/useBillboardPageContext";
import { atomizeUrl } from "pages/[tenant]/browse/utils/atomizePandaUrl";

import VideoPlayer from "shared/components/atoms/VideoPlayer";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import useWindowSize from "shared/utils/hooks/useWindowSize";

export const MediaBackground = () => {
  const { pandaPlayerRef, group, backgroundContent } =
    useBillboardPageContext();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [_, setFailedToLoadImage] = useState(false);

  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const { state } = useGlobalContext();
  const isIOS = state?.isIOS;

  const imageHref = useMemo(
    () => group?.cover_address || group?.cover_video?.thumbnail,
    [group],
  );

  const imageSrc = useMemo(
    () =>
      atomizeUrl({
        url: group?.cover_video?.player || group?.banner_video?.player,
        isIOS,
      }),
    [group?.cover_video?.player, group?.banner_video?.player, isIOS],
  );

  const handleError = () => {
    setFailedToLoadImage(true);
    setTimeout(() => setFailedToLoadImage(false), 50);
  };

  const mobileImageHref = group?.mobile_cover_image;

  const hasImageToShow = mobileImageHref || imageHref;

  const videoType = group?.billboard_video_type;

  let videoId =
    videoType === "panda"
      ? group?.billboard_video_link
      : group?.billboard_video_id;

  if (videoType === "wistia") {
    let wistiaId = group?.billboard_video_link?.split("/embed/iframe/")[1];
    videoId = wistiaId;
  }

  return (
    <>
      {!isMobile &&
        backgroundContent === "video" &&
        (!!group?.billboard_video_id || !!group?.billboard_video_link ? (
          <VideoPlayer
            lessonType={videoType}
            lessonLink={videoId}
            asBackgroundVideo
          />
        ) : (
          <iframe
            ref={pandaPlayerRef}
            id="panda-player"
            onLoad={() => setVideoLoaded(true)}
            style={{ opacity: videoLoaded ? "1" : "0" }}
            src={imageSrc}
          />
        ))}

      {hasImageToShow ? (
        <Image
          src={isMobile && mobileImageHref ? mobileImageHref : imageHref}
          alt=""
          fill
          quality={60}
          onError={handleError}
          className="background-image"
          priority
          fetchPriority="high"
          id="media-background"
        />
      ) : (
        <div
          className="background-image"
          style={{ backgroundColor: group?.primary_color }}
        ></div>
      )}
    </>
  );
};
